module.exports = __webpack_public_path__ + "img/part5-8.53581a15.png";